import React from 'react';

// Import your icons (replace file names with actual ones in your /assets/icon folder)
import expertiseIcon from '../../assets/icon/Expertise.svg';
import pricingIcon from '../../assets/icon/Competitive.svg';
import safetyIcon from '../../assets/icon/safety.svg';
import communityIcon from '../../assets/icon/Community.svg';

const features = [
  {
    title: 'Expertise and Experience',
    icon: expertiseIcon,
    desc: 'BlueLagoon Travels has a team of knowledgeable travel experts who are passionate about crafting unforgettable experiences.',
  },
  {
    title: 'Competitive Pricing',
    icon: pricingIcon,
    desc: 'Enjoy competitive rates without compromising on quality. BlueLagoon Travels seeks the best value for your travel budget.',
  },
  {
    title: 'Safety & Security',
    icon: safetyIcon,
    desc: 'Your safety is a top priority, with thorough planning and arrangements to ensure a secure journey.',
  },
  {
    title: 'Community Management',
    icon: communityIcon,
    desc: 'BlueLagoon Travels often collaborates with local communities, promoting cultural exchange and supporting local economies.',
  },
];

const WhyChoose = () => {
  return (
    <>
      <section className='relative bg-[#EDEFFF] py-10'>
        <div className='container relative mx-auto px-4 lg:px-16'>
          {/* Title */}
          <h1 className='mont mb-12 text-center text-2xl font-bold md:text-4xl'>Why Choose Us? </h1>

          <div className='grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4'>
            {features.map((item, index) => (
              <div
                key={index}
                className='service_card relative flex flex-col items-center rounded-lg p-8 text-center'
              >
                <div className='mb-4'>
                  <div className='rounded-full bg-white p-3'>
                    <img
                      src={item.icon}
                      alt={item.title}
                      className='h-24 w-24 object-contain'
                    />
                  </div>
                </div>
                <h3 className='mb-3 text-xl font-semibold text-gray-700'>{item.title}</h3>
                <p className='text-gray-700'>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom Wave SVG */}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 1200 100'
        preserveAspectRatio='none'
        style={{
          backgroundColor: 'transparent',
          display: 'block',
          height: '30px',
          position: 'relative',
          top: '-1px',
          width: '100%',
        }}
      >
        <path
          d='M851.8,100c125,0,288.3-45,348.2-64V0H0v44c3.7-1,7.3-1.9,11-2.9C80.7,22,151.7,10.8,223.5,6.3C276.7,2.9,330,4,383,9.8 c52.2,5.7,103.3,16.2,153.4,32.8C623.9,71.3,726.8,100,851.8,100z'
          style={{ fill: '#EDEFFF' }}
        />
      </svg>
    </>
  );
};

export default WhyChoose;
